import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const SummaryDiv = styled.div`
  padding: 15px 20px;
  background: ${COLORS.BLUE_T_97};
  border: 1px solid ${COLORS.BLUE_P_92};
  border-radius: 10px;
`
export const Summary = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: 16px;
  line-height: 21px;
  color: ${COLORS.BLACK};
  border-bottom: 1px solid ${COLORS.BLUE_T_90};
  padding: 0 0 15px 0;
  margin-bottom: 10px;
`
export const TitleDiv = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: 16px;
  line-height: 21px;
  color: ${COLORS.BLACK};
  margin: 15px 0 0;
`
export const CommonFlex = styled(Flex)`
  padding: 0 0 20px 0;
`
export const SubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
`
export const ContentDiv = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_10};
`
export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-left: 10px;
`
export const CollegeNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_20};
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const CollageDetailsFlex = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
  padding: 17px 0px;
  border-bottom: ${props =>
    !props?.isBoader && `1px solid ${COLORS.GREY_T_90}`};
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`

export const IconWrap = styled(Flex)`
  cursor: pointer;
`
